module.exports = __webpack_public_path__ + "static/media/salesforceProcess1.8d7f450d.png";